import { logError } from 'errors/errorHandler';

import AccessPolicyService from './services';
import AccessPolicyTypes from './types';

import type { IAccessPolicyPermissionsAction } from './interfaces';
import type IActionType from 'store/_utils/interfaces/IActionType';

export const listAccounts = () => AccessPolicyTypes.accounts.createAction(() => AccessPolicyService.listAccounts());
export const listGroups = () => AccessPolicyTypes.groups.createAction(() => AccessPolicyService.listGroups());
export const listUsers = () => AccessPolicyTypes.users.createAction(() => AccessPolicyService.listUsers());

export const getPermissions = (refresh: boolean = false) =>
  AccessPolicyTypes.permissions.createAction(null, (actionType: IActionType) => {
    return async (dispatch: any, getState: Function) => {
      const state = getState();
      if (!refresh && (state.orbita.AccessPolicy.permissions.data || state.orbita.AccessPolicy.permissions.isFetching)) {
        return;
      }
      try {
        dispatch({ type: actionType.request });
        let {
          data: { data },
        } = await AccessPolicyService.getPermissions();
        if (!data || Array.isArray(data)) {
          data = { owned: true, accesses: {} };
        }

        dispatch({
          type: actionType.success,
          payload: {
            data: {
              data: {
                owned: data.owned,
                actions: Object.keys(data.accesses).reduce((acc, key) => {
                  acc.push(...data.accesses[key].actions.map((a) => a.fullname));
                  return acc;
                }, []),
              } as IAccessPolicyPermissionsAction,
            },
          },
        });
      } catch (error) {
        dispatch({ type: actionType.error, error });
        logError(error);
      }
    };
  });

export function deleteGroup(id: number): any {
  return async () => {
    try {
      return await AccessPolicyService.deleteGroup(id);
    } catch (error) {
      logError(error);
      throw error;
    }
  };
}

export function deleteUser(id: number): any {
  return async () => {
    try {
      return await AccessPolicyService.deleteUser(id);
    } catch (error) {
      logError(error);
      throw error;
    }
  };
}
